import _, {cloneDeep} from "lodash";
import { Types } from "../actions/employeeActions";

const employeeReducers = (state, action) => {
	switch (action.type) {
		case Types.EMPLOYEE_SET_COLA: {
			let newState = _.cloneDeep(state);

			newState.cola.salaries = {
				...newState.cola.salaries,
				[action.agreementId]: action.newSalary,
			};

			return newState;
		}

		case Types.EMPLOYEE_CLEAR: {
			let newState = _.cloneDeep(state);

			newState.employee = {
				employeeDetails: {},
				taxSettings: [],
				selectedTax: null,
			};
			return newState;
		}

		case Types.EMPLOYEE_COLA_APPLYING: {
			let newState = _.cloneDeep(state);

			newState.cola.applyingCola = true;

			return newState;
		}

		case Types.EMPLOYEE_COLA_APPLY: {
			let newState = _.cloneDeep(state);

			newState.cola = {};

			return newState;
		}

		case Types.EMPLOYEE_CARRYOVER_APPLYING: {
			let newState = _.cloneDeep(state);

			newState.employees.applyingCarryover = true;

			return newState;
		}

		case Types.EMPLOYEE_CARRYOVER_APPLY: {
			let newState = _.cloneDeep(state);

			newState.employees.applyingCarryover = false;
			newState.employees.carryoverApplied = true;

			return newState;
		}
		case Types.EMPLOYEE_ATTACHMENT_EARNINGS_MODAL: {
			let newState = _.cloneDeep(state);

			newState.employee.attachmentEarnings = {
				...newState.employee.attachmentEarnings,
				attachmentEarningsModal: action.open ? action.open : undefined,
				attachment: action.attachment ? { ...action.attachment, payment: undefined } : undefined,
			};

			if (action.defaultType){
				newState.employee.attachmentEarnings.preselectedType = action.defaultType
			} else {
				delete newState.employee.attachmentEarnings.preselectedType
			}

			return newState;
		}
		case Types.EMPLOYEE_ATTACHMENT_EARNINGS_LIST: {
			let newState = _.cloneDeep(state);

			newState.employee.attachmentEarnings = {
				...newState.employee.attachmentEarnings,
				items: action.list,
			};

			return newState;
		}
		case Types.EMPLOYEE_ATTACHMENT_EARNINGS_LOADING: {
			let newState = _.cloneDeep(state);

			newState.employee.attachmentEarnings = {
				...newState.employee.attachmentEarnings,
				loading: action.toggle ? action.toggle : undefined,
			};

			return newState;
		}
		case Types.EMPLOYEE_ATTACHMENT_EARNINGS_SAVING: {
			let newState = _.cloneDeep(state);

			newState.employee.attachmentEarnings = {
				...newState.employee.attachmentEarnings,
				saving: action.toggle ? action.toggle : undefined,
			};

			return newState;
		}
		case Types.EMPLOYEE_CHILDREN_MODAL: {
			let newState = _.cloneDeep(state);

			newState.employee.children = {
				...newState.employee.children,
				childrenModal: action.open ? action.open : undefined,
				child: action.child ? action.child : undefined,
			};

			return newState;
		}
		case Types.EMPLOYEE_CHILD_LEAVE_MODAL: {
			let newState = _.cloneDeep(state);

			newState.employee.children = {
				...newState.employee.children,
				childLeaveModal: action.open ? action.open : undefined,
				child: action.child ? action.child : undefined,
			};

			if (!action.open) {
				newState.leave.filesUploaded = undefined;
				newState.leave.modalLeave = undefined;
			}
			if (action.newEntry) {
				newState.leave.modalLeave = { newEntry: true };
			} else {
				newState.leave.modalLeave = action.leave;
			}

			return newState;
		}
		case Types.EMPLOYEE_PENSION_ENROLMENT: {
			let newState = _.cloneDeep(state);

			newState.pensions.pensionEnrolment = {
				...newState.pensions.pensionEnrolment,
				[action.response.agreement]: action.response,
			};
			return newState;
		}
		case Types.EMPLOYEE_CHILDREN_LIST: {
			let newState = _.cloneDeep(state);

			newState.employee.children = {
				...newState.employee.children,
				list: action.list,
				leave: action.leave,
			};

			return newState;
		}
		case Types.EMPLOYEE_CHILDREN_LOADING: {
			let newState = _.cloneDeep(state);

			newState.employee.children = {
				...newState.employee.children,
				loading: action.toggle ? action.toggle : undefined,
			};

			return newState;
		}
		case Types.EMPLOYEE_CHILDREN_SAVING: {
			let newState = _.cloneDeep(state);

			newState.employee.children = {
				...newState.employee.children,
				saving: action.toggle ? action.toggle : undefined,
			};

			return newState;
		}
		case Types.EMPLOYEE_PAYMENT_HISTORY_MODAL: {
			let newState = _.cloneDeep(state);

			newState.employee.attachmentEarnings = {
				...newState.employee.attachmentEarnings,
				paymentHistoryModal: action.open ? action.open : undefined,
				payments: action.payments ? action.payments : undefined,
			};

			return newState;
		}

		case Types.EMPLOYEE_SET_COLA_ROUNDING: {
			let newState = _.cloneDeep(state);

			if (!newState.cola.rounding) newState.cola.rounding = true;
			else newState.cola.rounding = undefined;

			return newState;
		}
		case Types.EMPLOYEE_SET_COLA_PRE_APPLIED: {
			let newState = _.cloneDeep(state);

			if (!newState.cola.preApplied) newState.cola.preApplied = true;
			else newState.cola.preApplied = false;

			return newState;
		}
		case Types.EMPLOYEE_COLA_PERIOD: {
			let newState = _.cloneDeep(state);

			if (!newState.cola.applyFirstPeriod) newState.cola.applyFirstPeriod = true;
			else newState.cola.applyFirstPeriod = undefined;

			return newState;
		}
		case Types.EMPLOYEE_COLA_REQUIRED: {
			let newState = _.cloneDeep(state);

			newState.cola = {
				...newState.cola,
				...action.data,
			};

			return newState;
		}

		case Types.EMPLOYEE_SET_CARRYOVER: {
			let newState = _.cloneDeep(state);

			if (!newState.employees.carryover) {
				newState.employees.carryover = {};
			}

			const employeeCarryover = { carryover: action.carryover, toPay: action.toPay, isValid: action.isValid };

			newState.employees.carryover = {
				...newState.employees.carryover,
				[action.agreementId]: employeeCarryover,
			};

			return newState;
		}

		case Types.EMPLOYEE_COLA_MODAL: {
			let newState = _.cloneDeep(state);

			newState.cola.isModalOpen = action.status ? action.status : undefined;

			return newState;
		}

		case Types.EMPLOYEES_FILE_UPLOADING: {
			let newState = _.cloneDeep(state);

			newState.employees.filesUploading = newState.employees.filesUploading
				? [...newState.employees.filesUploading, action.file]
				: [action.file];

			return newState;
		}
		case Types.EMPLOYEES_FILE_UPLOADED: {
			let newState = _.cloneDeep(state);

			newState.employees.filesUploading = newState.employees.filesUploading.filter((name) => name != action.file);

			const fileDetails = { name: action.file, key: action.key };
			newState.employees.filesUploaded = newState.employees.filesUploaded
				? [...newState.employees.filesUploaded, fileDetails]
				: [fileDetails];

			return newState;
		}
		case Types.EMPLOYEES_IMPORT_MODAL: {
			let newState = _.cloneDeep(state);

			newState.employees = {
				...newState.employees,
				importModal: action.status ? action.status : undefined,
			};

			if (!newState.employees.importModal) {
				// clear any results when modal closed
				newState.employees.uploadResults = null;
				newState.employees.filesUploading = [];
			}

			return newState;
		}
		case Types.EMPLOYEES_CLEAR_IMPORT_RESULTS: {
			let newState = _.cloneDeep(state);

			newState.employees.uploadResults = null;
			newState.employees.filesUploading = [];

			return newState;
		}
		case Types.EMPLOYEES_PROCESSING_IMPORT: {
			let newState = _.cloneDeep(state);

			newState.employees.importingEmployees = action.status ? action.status : undefined;

			return newState;
		}
		case Types.EMPLOYEES_IMPORT_PE_MODAL: {
			let newState = _.cloneDeep(state);

			newState.employee.peImportModal = action.status ? action.status : undefined;
			newState.employee.uploadResults = undefined;

			return newState;
		}
		case Types.EMPLOYEE_DELETE_MODAL: {
			let newState = _.cloneDeep(state);
			newState.company.adminDeleteModal = {
				open: action.open,
				message: action.message,
				agreement: action.agreement,
			};
			return newState;
		}

		case Types.EMPLOYEES_UPLOAD_TEMPLATE: {
			let newState = _.cloneDeep(state);

			newState.employees = {
				...newState.employees,
				uploadTemplate: action.template,
			};

			return newState;
		}
		case Types.EMPLOYEES_FIELD_MAPPING: {
			let newState = _.cloneDeep(state);

			const {
				headers,
				fields,
				sampleRows,
				innerMapping,
			} = action;

			newState.employees = {
				...newState.employees,
				uploadMapping: {
					headers,
					fields,
					sampleRows,
					innerMapping,
				}
			};

			return newState;
		}
		case Types.EMPLOYEES_FIELD_UPDATE_DEFAULT_MAPPING: {
			let newState = _.cloneDeep(state);

			const {
				column,
				item
			} = action;
			if (!newState.employees.uploadMapping.default) {
				newState.employees.uploadMapping.default = {}
			}

			newState.employees.uploadMapping.default[`${column.group}#${column.field}`] = item;

			return newState;
		}
		case Types.EMPLOYEES_FIELD_UPDATE_MAPPING: {
			let newState = _.cloneDeep(state);

			const {
				header,
				value,
				response,
				innerMapping
			} = action;

			newState.employees.uploadMapping = {
				...newState.employees.uploadMapping,
				headers: [
					...newState.employees.uploadMapping.headers
				]
			};

			const headerIndex = newState.employees.uploadMapping.headers.findIndex(h => h?.header === header);

			if (response){
				newState.employees.uploadMapping.headers[headerIndex] = response
				if (!innerMapping){
					delete newState.employees.uploadMapping.innerMapping[header];
				} else {
					newState.employees.uploadMapping.innerMapping[header] = innerMapping
				}
			} else {
				const group = value && newState.employees.uploadMapping.fields.find(f => f?.name === value?.group);

				const field = value && group.options.find(f => f?.name === value?.label);

				newState.employees.uploadMapping.headers[headerIndex] = _.cloneDeep(newState.employees.uploadMapping.headers[headerIndex]);
				newState.employees.uploadMapping.headers[headerIndex].matchedField = field ?? null;
			}

			return newState;
		}
		case Types.EMPLOYEES_FIELD_UPDATE_INNER_MAPPING: {
			let newState = _.cloneDeep(state);

			const {
				header,
				key,
				item
			} = action;

			newState.employees.uploadMapping.innerMapping = {
				...newState.employees.uploadMapping.innerMapping,
				[header]: {
					...newState.employees.uploadMapping.innerMapping[header],
					[key]: item
				}
			};

			return newState;
		}

		case Types.EMPLOYEES_UPLOADING: {
			let newState = _.cloneDeep(state);

			newState.employees = {
				...newState.employees,
				uploading: true,
			};

			return newState;
		}
		case Types.EMPLOYEES_UPLOADED: {
			let newState = _.cloneDeep(state);

			newState.employees = {
				...newState.employees,
				uploading: false,
				uploadResults: action.payload,
			};

			return newState;
		}
		case Types.EMPLOYEE_PE_UPLOADING: {
			let newState = _.cloneDeep(state);

			newState.employee.uploading = true;

			return newState;
		}
		case Types.EMPLOYEE_PE_UPLOADED: {
			let newState = _.cloneDeep(state);

			newState.employee.uploading = undefined;
			newState.employee.uploadResults = action.payload;

			// ensure they are sorted by row
			Object.keys(newState.employee.uploadResults).forEach((key) => {
				newState.employee.uploadResults[key].sort((a, b) => a.row - b.row);
			})

			return newState;
		}
		case Types.EMPLOYEE_APPLY_GRADE: {
			let newState = _.cloneDeep(state);

			newState.grades = {
				...newState.grades,
				apply: false,
			};

			return newState;
		}
		case Types.EMPLOYEES_SINGLE_INVITE_SENDING_STATUS: {
			let newState = _.cloneDeep(state);

			newState.employee.sendingInvite = action.status;
			newState.employee.inviteSent = !action.status;

			return newState;
		}
		case Types.EMPLOYEES_SENT_INVITE_AGREEMENT: {
			let newState = _.cloneDeep(state);

			newState.employee.sentInvite = action.status;

			return newState;
		}
		case Types.EMPLOYEES_INVITE_SENT_STATUS: {
			let newState = _.cloneDeep(state);

			newState.employees.invitesSent = action.sent;
			newState.employees.totalInvitesToSend = action.total;

			return newState;
		}
		case Types.EMPLOYEE_NEW_MODAL_OPEN: {
			let newState = _.cloneDeep(state);
			newState.isNewEmployeeModalOpen = action.isNewEmployeeModalOpen;
			newState.occupationModal = action.forOccupation ? action.forOccupation : undefined;

			if (action.keepEmployee) return newState;

			newState.employee = { ...action.details, salaries: [], previousEarnings: [], taxSettings: [], roles: [] };

			newState.grades.apply = null;

			return newState;
		}
		case Types.EMPLOYEES_SHOW_INVITE_MODAL: {
			let newState = _.cloneDeep(state);

			newState.employees.inviteModal = action.status;

			return newState;
		}
		case Types.EMPLOYEES_UPDATE_LIST: {
			let newState = _.cloneDeep(state);

			console.log("action", action);
			newState.employees.employeeList = action.payload.employees;

			return newState;
		}
		case Types.EMPLOYEES_UPDATE_TERMINATED_LIST: {
			let newState = _.cloneDeep(state);

			console.log("action", action);
			newState.employees.terminatedEmployees = action.payload.employees;

			return newState;
		}
		case Types.EMPLOYEES_UPDATE_LIST_WITH_SALARY: {
			let newState = _.cloneDeep(state);

			newState.employees = { ...newState.employees };
			newState.employees.employeeListWithSalary = action.payload.employees || [];

			const newEmployeeByReference = {};

			newState.employees.employeeListWithSalary.map((employee) => {
				if (employee.reference && employee.reference !== "undefined") {
					newEmployeeByReference[employee.reference] = employee;
				}
			});

			newState.employees.employeesByReference = newEmployeeByReference;

			return newState;
		}
		case Types.EMPLOYEES_UPDATE_EMPLOYEE_REFERENCE: {
			let newState = _.cloneDeep(state);

			/*const {reference, employeeID}

      let employee;

      if (newState.employees.employeeListWithSalary){
        // employee = _.find()
      } else {

      }

      newState.employees.employeeListWithSalary[] = action.payload.employees;

      const newEmployeeByReference = {}

      newState.employees.employeeListWithSalary.map(employee => {
        if (employee.reference){
          newEmployeeByReference[employee.reference] = employee
        }
      })

      if (employee){
        newState.employees.employeesByReference[reference] = employee  
      }*/

			return newState;
		}
		case Types.EMPLOYEE_TAB: {
			let newState = _.cloneDeep(state);

			newState.employee.tab = action.tab;

			return newState;
		}

		case Types.EMPLOYEE_DETAILS: {
			let newState = _.cloneDeep(state);

			newState.employee = { ...action.payload, tab: newState.employee.tab };

			return newState;
		}

		case Types.EMPLOYEE_SET_ROLE: {
			let newState = _.cloneDeep(state);

			newState.employee.selectedRole = action.roleID;

			return newState;
		}
		case Types.EMPLOYEE_SET_DEPARTMENT: {
			let newState = _.cloneDeep(state);

			newState.employee.selectedDepartment = action.departmentID;

			return newState;
		}
		case Types.EMPLOYEE_UPDATE_DETAILS_MODAL: {
			let newState = _.cloneDeep(state);
			const { type, status, ...details } = action;
			newState.employee.updateDetailsModal = status ? details : undefined;
			return newState;
		}
		case Types.EMPLOYEE_UPDATING_DETAILS_MODAL: {
			let newState = _.cloneDeep(state);
			const { status } = action;
			newState.employee.updateDetailsModal = {
				...newState.employee.updateDetailsModal,
				saving: status ? status : undefined,
			};
			return newState;
		}
		case Types.EMPLOYEE_DELETE_DETAILS_MODAL: {
			let newState = _.cloneDeep(state);
			const { type, status, ...details } = action;
			newState.employee.deleteDetailsModal = status ? details : undefined;
			return newState;
		}
		case Types.EMPLOYEE_DELETING_DETAILS_MODAL: {
			let newState = _.cloneDeep(state);
			const { status } = action;
			newState.employee.deleteDetailsModal = {
				...newState.employee.deleteDetailsModal,
				saving: status ? status : undefined,
			};
			return newState;
		}
		case Types.EMPLOYEE_SET_SALARY: {
			let newState = _.cloneDeep(state);

			newState.employee.selectedSalary = action.salaryId;

			return newState;
		}
		case Types.EMPLOYEE_SET_TAX: {
			let newState = _.cloneDeep(state);

			newState.employee.selectedTax = action.taxId;

			return newState;
		}
		case Types.EMPLOYEE_SAVING_EARNINGS: {
			let newState = _.cloneDeep(state);

			newState.employee = { ...newState.employee, savingPreviousEarnings: true };

			return newState;
		}
		case Types.EMPLOYEE_PREVIOUS_EARNINGS: {
			let newState = _.cloneDeep(state);

			newState.employee = {
				...newState.employee,
				savingPreviousEarnings: false,
				lastUpdatedPreviousEarnings: new Date(),
			};

			return newState;
		}
		case Types.EMPLOYEE_SAVING_BANK: {
			let newState = _.cloneDeep(state);

			newState.employee = { ...newState.employee, savingBank: true };

			return newState;
		}
		case Types.EMPLOYEE_SAVED_BANK: {
			let newState = _.cloneDeep(state);

			newState.employee = { ...newState.employee, savingBank: false, lastSavedBank: new Date() };

			return newState;
		}
		case Types.EMPLOYEE_SAVED_PAY_BY_BANK: {
			let newState = _.cloneDeep(state);

			newState.employee = { ...newState.employee, lastSavedBank: new Date() };

      return newState;
    }
    case Types.EMPLOYEE_BACKPAY_CALCULATING:{

      let newState = _.cloneDeep(state);

      newState.employee.backpay = {
        calculating: action.status
      }
      return newState;
    }
    case Types.EMPLOYEE_BACKPAY_CALCULATED:{

      let newState = _.cloneDeep(state);

      // newState.employee = {
      //   ...newState.employee,
      newState.employee.backpay = {
          calculating: false,
          data: action.data
        }
      // };
			return newState;
		}
		case Types.EMPLOYEE_CONFIRM_CHANGE_MODAL: {
			let newState = _.cloneDeep(state);

			if (!action.status) newState.employee.confirmModal = undefined;

			newState.employee = {
				...newState.employee,
				confirmModal: {
					input: action.input,
					status: action.status,
					type: action.formType,
					previousDate: action.previousDate,
					minDate: action.minDate,
					maxDate: action.maxDate,
					fixedDate: action.fixedDate,
					cannotReplace: action.cannotReplace,
					cannotCreateNew: action.cannotCreateNew,
					dateType: action.dateType,
				},
			};

			return newState;
		}
		case Types.EMPLOYEE_SAVING_CHANGE_MODAL: {
			let newState = _.cloneDeep(state);

			newState.employee = {
				...newState.employee,
				confirmModal: {
					...newState.employee.confirmModal,
					saving: action.status ? action.status : undefined,
				},
			};

			return newState;
		}
		case Types.EMPLOYEE_SAVED_CHANGE_MODAL: {
			let newState = _.cloneDeep(state);

			newState.employee = {
				...newState.employee,
				confirmModal: {
					...newState.employee.confirmModal,
					saved: true,
					saving: false,
				},
			};

			return newState;
		}
		case Types.EMPLOYEE_DELETE_SALARY_MODAL: {
			let newState = _.cloneDeep(state);

			newState.employee = {
				...newState.employee,
				deleteSalaryModal: {
					show: action.status,
				},
			};

			return newState;
		}
		case Types.EMPLOYEE_DELETE_PENSION_MODAL: {
			let newState = _.cloneDeep(state);

			newState.employee = {
				...newState.employee,
				deletePensionModal: {
					show: action.status,
				},
			};

			return newState;
		}
		case Types.EMPLOYEE_DELETE_TAX_MODAL: {
			let newState = _.cloneDeep(state);

			newState.employee = {
				...newState.employee,
				deleteTaxModal: {
					show: action.status,
				},
			};

			return newState;
		}
		case Types.EMPLOYEE_DELETING_TAX: {
			let newState = _.cloneDeep(state);

			newState.employee = {
				...newState.employee,
				deleteTaxModal: {
					...newState.employee.deleteTaxModal,
					deleting: true,
				},
			};

			return newState;
		}
		case Types.EMPLOYEE_MFA_STATUS_MODAL: {
			let newState = _.cloneDeep(state);

			newState.employee.mfaStatusModal = action.toggle ? true : undefined;

			return newState;
		}
		case Types.EMPLOYEE_RESET_MFA: {
			let newState = _.cloneDeep(state);

			newState.employee.agreementInfo = {
				...newState.employee.agreementInfo,
				hasMFA: false,
			};

			return newState;
		}
		case Types.EMPLOYEE_DELETED_TAX: {
			let newState = _.cloneDeep(state);

			// auto-select to salary prior to the deleted one so nothing crashes
			const selectedTax = newState.employee.taxSettings[newState.employee.taxSettings.length - 2].id;

			newState.employee = {
				...newState.employee,
				deleteTaxModal: {
					...newState.employee.deleteTaxModal,
					deleted: true,
					deleting: false,
				},
				selectedTax,
			};

			return newState;
		}
		case Types.EMPLOYEE_DELETING_SALARY: {
			let newState = _.cloneDeep(state);

			newState.employee = {
				...newState.employee,
				deleteSalaryModal: {
					...newState.employee.deleteSalaryModal,
					deleting: true,
				},
			};

			return newState;
		}
		case Types.EMPLOYEE_DELETED_SALARY: {
			let newState = _.cloneDeep(state);

			// auto-select to salary prior to the deleted one so nothing crashes
			const selectedSalary = newState.employee.salaries[newState.employee.salaries.length - 2].salary_id;

			newState.employee = {
				...newState.employee,
				deleteSalaryModal: {
					...newState.employee.deleteSalaryModal,
					deleted: true,
					deleting: false,
				},
				selectedSalary,
			};

			return newState;
		}
		case Types.EMPLOYEE_DELETING_PENSION: {
			let newState = _.cloneDeep(state);

			newState.employee = {
				...newState.employee,
				deletePensionModal: {
					...newState.employee.deletePensionModal,
					deleting: action.status ? action.status : undefined,
				},
			};

			return newState;
		}
		case Types.EMPLOYEE_TAX_OPTIONS: {
			let newState = _.cloneDeep(state);

			newState.taxOptions = action.payload;

			return newState;
		}
		case Types.EMPLOYEE_SAVING_ENGAGEMENT_DATE: {
			let newState = _.cloneDeep(state);

			newState.employee = {
				...newState.employee,
				engagementDateSaving: true,
			};

			return newState;
		}
		case Types.EMPLOYEE_UPDATED_ENGAGEMENT_DATE: {
			let newState = _.cloneDeep(state);

			newState.employee = {
				...newState.employee,
				engagementDateModal: false,
				engagementDateSaving: false,
			};

			return newState;
		}
		case Types.EMPLOYEE_ENGAGEMENT_DATE_MODAL: {
			let newState = _.cloneDeep(state);

			newState.employee = {
				...newState.employee,
				engagementDateModal: action.status,
			};

			return newState;
		}
		case Types.EMPLOYEE_TERMINATION_DATE_MODAL: {
			let newState = _.cloneDeep(state);

			newState.employee = {
				...newState.employee,
				terminationDateModal: action.status,
			};

			return newState;
		}
		case Types.EMPLOYEE_SAVING_TERMINATION_DATE: {
			let newState = _.cloneDeep(state);

			newState.employee = {
				...newState.employee,
				terminationDateSaving: action.status ? action.status : undefined,
			};

			return newState;
		}
		case Types.EMPLOYEE_SET_TERMINATION_DATE: {
			let newState = _.cloneDeep(state);

			newState.employee = {
				...newState.employee,
				terminationDateModal: false,
				terminationDateSaving: false,
			};

			return newState;
		}
		case Types.EMPLOYEE_AUDIT_LOGS: {
			let newState = _.cloneDeep(state);

			newState.employee = {
				...newState.employee,
				auditLogs: {
					items:
						action.extend && newState.employee.auditLogs
							? [...newState.employee.auditLogs.items, ...action.data]
							: action.data,
					nextToken: action.nextToken,
					count: action.extend
						? ((newState.employee.auditLogs && newState.employee.auditLogs.count) || 0) + action.data.length
						: action.data,
				},
			};

			return newState;
		}
		case Types.EMPLOYEE_NOTES: {
			let newState = _.cloneDeep(state);

			newState.employee = {
				...newState.employee,
				notes: {
					items:
						action.extend && newState.employee.notes
							? [...newState.employee.notes.items, ...action.payload.items]
							: action.payload.items,
					nextToken: action.payload.nextToken,
					count: action.extend
						? ((newState.employee.notes && newState.employee.notes.count) || 0) + action.payload.count
						: action.payload.count,
				},
			};

			return newState;
		}
		case Types.EMPLOYEE_UNLINK_GRADE: {
			let newState = _.cloneDeep(state);

			// find selected grade and move into employee record
			const gradeId = newState.grades?.apply?.id;
			const gradeSalary = { ...(newState.grades?.apply?.salary || {}) };

			if (gradeId) {
				gradeSalary.salaryAmount = gradeSalary.amount;
				gradeSalary.isManagerial = gradeSalary.manager;
				gradeSalary.suspendBonus = gradeSalary["suspend-bonus"];
				gradeSalary.workingDays = gradeSalary["working-days"];
				gradeSalary.weeklyHours = gradeSalary["weekly-hours"];
				gradeSalary.casual = gradeSalary["casual-worker"];
				gradeSalary.employmentType = gradeSalary["employment-type"];
				gradeSalary.salaryPeriod = gradeSalary.period;
				delete gradeSalary.amount;
				delete gradeSalary.manager;
				delete gradeSalary["suspend-bonus"];
				delete gradeSalary["working-days"];
				delete gradeSalary["weekly-hours"];
				delete gradeSalary["casual-worker"];
				delete gradeSalary["employment-type"];
				delete gradeSalary.period;
			}

			delete newState.grades.apply;

			if (gradeId)
				newState.employee.salaries[0] = {
					...gradeSalary, // ideally salary should be separate...
				};

			const employeeSalaries = newState.employee?.salaries;
			const lastSalary = employeeSalaries?.[employeeSalaries?.length - 1];

			if (lastSalary?.grade) {
				delete newState.employee.salaries[employeeSalaries.length - 1].grade;
			}

			return newState;
		}
		case Types.EMPLOYEE_UPDATED: {
			let newState = _.cloneDeep(state);
			newState.employee = {
				...newState.employee,
				agreementInfo: { ...action.employee },
			};
			return newState;
		}
		case Types.EMPLOYEE_UPDATED_INFO: {
			let newState = _.cloneDeep(state);
			newState.employee = {
				...newState.employee,
				...action.data,
			};
			return newState;
		}
		case Types.EMPLOYEE_NEW_DETAILS_UPDATED: {
			let newState = _.cloneDeep(state);
			newState.employee.employeeDetails = { ...newState.employee.employeeDetails };
			for (const [key, value] of Object.entries(action.data)) {
				newState.employee.employeeDetails[key] = value;
			}
			return newState;
		}

		case Types.EMPLOYEE_NEW_DETAILS_PREVIOUS_EARNINGS: {
			let newState = _.cloneDeep(state);
			newState.employee.previousEarnings[0] = { ...newState.employee.previousEarnings[0] };
			for (const [key, value] of Object.entries(action.data)) {
				newState.employee.previousEarnings[0][key] = value;
			}
			return newState;
		}

		case Types.EMPLOYEE_NEW_DETAILS_ROLE: {
			let newState = _.cloneDeep(state);
			newState.employee.roles = [{ ...(newState.employee?.roles?.[0] || []) }];
			for (const [key, value] of Object.entries(action.data)) {
				newState.employee.roles[0][key] = value;
			}
			delete newState.employee.roles[0].role;
			return newState;
		}

		case Types.EMPLOYEE_NEW_DETAILS_SALARY: {
			let newState = _.cloneDeep(state);
			newState.employee.salaries[0] = { ...newState.employee.salaries[0] };
			for (const [key, value] of Object.entries(action.data)) {
				newState.employee.salaries[0][key] = value;
			}
			return newState;
		}

		case Types.EMPLOYEE_NEW_DETAILS_TAX: {
			let newState = _.cloneDeep(state);
			newState.employee.taxSettings[0] = { ...newState.employee.taxSettings[0] };
			for (const [key, value] of Object.entries(action.data)) {
				newState.employee.taxSettings[0][key] = value;
			}
			return newState;
		}

		case Types.EMPLOYEE_SET_BULK_CHANGES_MODAL: {
			let newState = _.cloneDeep(state);
			newState.employees.bulkChangesModalOpen = action.isOpen;
			return newState;
		}
		case Types.EMPLOYEE_SAVE_FILTERS: {
			let newState = _.cloneDeep(state);

			newState.employees.filters = action.filters;
			newState.employees.changes = action.changes;

			return newState;
		}

		default:
			return state;
	}
};

export default employeeReducers;
